export class PlanYearFilter  {
    readonly YEAR_26 : string = "2026";
    readonly YEAR_25 : string = "2025";
    readonly YEAR_24 : string = "2024";
    readonly YEAR_23 : string = "2023";
    readonly YEAR_22 : string = "2022";
    readonly YEAR_21 : string = "2021";
    readonly YEAR_20 : string = "2020";
    readonly YEAR_19 : string = "2019";
    readonly YEAR_18 : string = "2018";
    readonly YEAR_17 : string = "2017";
    readonly YEAR_16 : string = "2016";
    readonly YEAR_15 : string = "2015";
    readonly YEAR_14 : string = "2014";
    readonly YEAR_13 : string = "2013";
    readonly YEAR_12 : string = "2012";
    readonly YEAR_11 : string = "2011";
    readonly YEAR_10 : string = "2010";
    readonly YEAR_09 : string = "2009";
}